{
  "BsoAttachmentsElement": {
    "title": "Anhänge hochladen"
  },
  "mask": {
    "BsoAttachmentsElement": {
      "groupTitle": "Hochladen",
      "showError": "Fehler anzeigen",
      "bsoOrigin": "Herkunft",
      "bsoCategory": "Kategorie",
      "accept": "Akzeptieren",
      "acceptPlaceholder": "z.B. .doc,.docx,application/msword",
      "multiple": "Mehrere zulassen",
      "renderAsList": "Als Liste aus Upload-Feldern anzeigen",
      "validationMaxAttachmentSize": "Max. Dateigröße (MB)",
      "validationMaxAttachments": "Maximale Anzahl von Dateien",
      "attachmentInputListSettings": "Upload Einstellungen",
      "required": "Erforderlich"
    }
  }
}